import { AutopilotSidebar as BaseAutopilotSidebar } from 'screens/VirtualMarketerOnboarding/AutopilotSidebar/AutopilotSidebar'

export const AutopilotSidebar = () => {
  return (
    <BaseAutopilotSidebar
      sections={[
        {
          heading: 'Why we ask this',
          text: 'Your goals and key dates help us build campaigns that actually move your business forward, not just fill a content calendar.',
        },
        {
          heading: 'Not sure what to include?',
          text: "Think about launches, seasonal peaks, or industry events you want to capitalize on. We'll build content themes around them.",
        },
      ]}
    />
  )
}
